import { getPrograma, update } from "../index";
import { Interesados as Subs } from '../../../Suscripciones';
export default function Interesados() {
    const p = getPrograma();
    return <Subs i={p.interesados} url={`programa/${p.id}`} u={update} />
}